import { useBrand } from "core/hooks/useBrand";
import { useMemo } from "react";
import { useBearerToken } from "./useBearerToken";
import { useBrandRegionCode } from "./useBrandRegionCode";
import { useRegion } from "./useRegion";

export function useAPIHeaders() {
  const brandRegionCode = useBrandRegionCode();
  const token = useBearerToken();
  const countryIso2AlphaCode = useRegion();
  const { brandTwoLetterCode, brandCode } = useBrand();

  const headers = useMemo(() => {
    const initialHeaders: HeadersInit = {
      "x-fixnetwork-brand": brandCode ?? "",
      "x-fixnetwork-region": brandRegionCode ?? "",
      "x-fixnetwork-brand-two-letter": brandTwoLetterCode ?? "",
      "x-fixnetwork-country-iso2": countryIso2AlphaCode ?? "",
    };

    if (token) {
      initialHeaders.Authorization = `Bearer ${token}`;
    }
    return initialHeaders;
  }, [
    brandCode,
    brandRegionCode,
    brandTwoLetterCode,
    countryIso2AlphaCode,
    token,
  ]);

  return headers;
}
